<template>
  <div class="flex items-center relative z-0 shrink-0" :style="style">
    <app-user-avatar
      v-for="(user, index) in list.slice(0, max)"
      :key="user.id"
      :avatar-url="user.avatar_url"
      class="absolute left-(--xOffset) -z-(--index) !w-(--width) !h-(--height) ring-1 ring-white"
      :name="user.full_name"
      :size="size * 3"
      :style="{
        '--width': `${size}px`,
        '--height': `${size}px`,
        '--xOffset': `${(index * size) / 2}px`,
        '--index': index,
      }"
    />
  </div>
</template>

<script lang="ts" setup>
const properties = withDefaults(
  defineProps<{
    list: Pick<DatabaseTable<"users">, "id" | "full_name" | "avatar_url">[];
    size?: number;
    max?: number;
  }>(),
  {
    size: 24,
    max: 3,
  },
);

const style = computed(() => {
  return {
    width: `${
      properties.size +
      ((Math.min(properties.list.length, properties.max) - 1) *
        properties.size) /
        2
    }px`,
    height: `${properties.size}px`,
  };
});
</script>
